import { useCallback } from 'react'

import {
  useCreateSelectOptionMutation,
  useGetSelectOptionsQuery,
  useRemoveSelectOptionMutation,
  useUpdateSelectOptionMutation
} from '../services/selectOption'
import { useManageField } from './useManageFields'

export function useManageSelectOptions() {
  const { selectedFieldId } = useManageField()

  const { data: options, isLoading } = useGetSelectOptionsQuery(
    { fieldId: selectedFieldId },
    { skip: !selectedFieldId }
  )

  const [createSelectOption] = useCreateSelectOptionMutation()
  const [updateSelectOption] = useUpdateSelectOptionMutation()
  const [removeSelectOption] = useRemoveSelectOptionMutation()

  const createOption = useCallback(
    async (fieldId) => {
      const optionValue = `-- Nova opção --`
      const payload = { value: optionValue, description: optionValue }
      await createSelectOption({ fieldId, payload })
    },
    [createSelectOption]
  )

  const updateOption = useCallback(
    async ({ option, fieldId }) => {
      await updateSelectOption({ fieldId, payload: option })
    },
    [updateSelectOption]
  )

  const removeOption = useCallback(
    async ({ optionId, fieldId }) => {
      await removeSelectOption({ fieldId, optionId })
    },
    [removeSelectOption]
  )

  return {
    isLoading,
    options,
    createOption,
    updateOption,
    removeOption
  }
}
